import css from './textfield.css';

export const InputCounter: FC<{ min: number; max: number; currentLength: number }> = ({ min, max, currentLength }) => {
    const hasError = currentLength < min;

    return (
        <div className={css.count} style={{ color: hasError ? 'red' : undefined }}>
            {hasError ? `-${min - currentLength}` : currentLength} / {max}
        </div>
    );
};
